'use client';

import { ComboboxTrigger } from "../../combobox/trigger/ComboboxTrigger.mjs";
/**
 * A button that opens the popup.
 * Renders a `<button>` element.
 *
 * Documentation: [Base UI Autocomplete](https://base-ui.com/react/components/autocomplete)
 */
export const AutocompleteTrigger = ComboboxTrigger;